module.exports = __webpack_public_path__ + "img/appstore.2928664f.svg";